export enum ConfigurationComparisonEnum {
    Unknown = -1,
    Ok = 0,
    Different = 1,
}
